import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import { Button, Form, Input } from "antd";
import { appMessage } from "../../hooks/useAppMessage";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ForgotPasswordAPI } from "../../API/ForgotPasswordAPI";

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not valid!",
  },
};
const validPasswordRgex =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,14}$/;

export default function ChangePasswordPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loadingState, setLoadingState] = useState(false);

  async function changePswdAPIFun(bodydata) {
    setLoadingState(true);
    await ForgotPasswordAPI.postChangePswd(bodydata)
      .then((res) => {
        if (res.data?.status === true) {
          appMessage.success(res.data?.message, 6);
          localStorage.setItem("forgotEmail", "");
          localStorage.setItem("otpKey", "");
          navigate("/login");
        } else {
          appMessage.error(res?.message, 8);
        }
      })
      .catch(() => appMessage.error("Internal Server Error", 8))
      .finally(() => setLoadingState(false));
  }

  const changepswdFun = (values) => {
    const bodyData = {
      email: values.email.trim(),
      password: values.newPassword.trim(),
      confirm_password: values.confirmPassword.trim(),
      verfification_key: localStorage.getItem("otpKey"),
    };
    changePswdAPIFun(bodyData);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (
      !localStorage.getItem("forgotEmail") ||
      !localStorage.getItem("otpKey")
    ) {
      navigate("/forgot-password");
    }
  }, []);

  const handleEmailChange = (e) => {
    const trimmedValue = e.target.value.trim();
    form.setFieldsValue({ email: trimmedValue });
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        background: "#fff",
      }}
    >
      <Helmet>
        <title>SpecOptimizer</title>
      </Helmet>
      <div
        style={{
          overflow: "hidden",
          background: "linear-gradient(180deg, #D3E4FF 0%, #FFFFFF 100%)",
          height: "100%",
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        <div className="reset_password_wraper">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              width: "60%",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={logo}
                style={{ marginBottom: "40px", width: "200px" }}
                alt={`img_${logo}`}
              />
              {/* <p className='reset_paragraph'>For continued access, please reset your password.</p> */}
            </div>
            <Form
              form={form}
              name="forgot_reset_password"
              className="login-form"
              onFinish={changepswdFun}
              initialValues={{ email: localStorage.getItem("forgotEmail") }}
              autoComplete="off"
              layout="vertical"
              requiredMark="optional"
              validateMessages={validateMessages}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input
                  name="email"
                  size="large"
                  disabled={true}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  onChange={handleEmailChange}
                />
              </Form.Item>
              <Form.Item
                name="newPassword"
                label="New Password"
                rules={[
                  { required: true },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || validPasswordRgex.test(value)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "Password must be 8–14 characters with at least one letter, one number, and one special character."
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  name="newPassword"
                  size="large"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                label="Confirm New Password"
                rules={[
                  { required: true },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("newPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The new password that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  name="confirmPassword"
                  size="large"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                />
              </Form.Item>

              <Form.Item style={{}}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  style={{ width: "100%", marginTop: "20px" }}
                  loading={loadingState}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
